export default {
    setItem(c_name, value)
    {
        localStorage.setItem(c_name, value);
    },
    getItem(c_name)
    {
        return localStorage.getItem(c_name);
    },
    getItemJson(c_name)
    {
        let item = localStorage.getItem(c_name);
        if (item){
            try {
                return JSON.parse(item);
            } catch (e){
                return null;
            }
        } else {
            return null;
        }
    },
}